import { configureStore } from '@reduxjs/toolkit';
import { rootReducer, RootState } from './rootReducer';

const store = configureStore({
  reducer: rootReducer,
});

if (import.meta.hot) {
  import.meta.hot.accept('./rootReducer', async () => {
    const { rootReducer: newRootReducer } = await import('./rootReducer');
    store.replaceReducer(newRootReducer);
  });
}

export type AppDispatch = typeof store.dispatch;

export type ThunkResult<R> = (
  dispatch: AppDispatch,
  getState: () => RootState,
  extraArgument: undefined,
) => R;

export const STORE = store;
